/**
 * Created by tomers on 12/24/2014.
 */
define(function (require) {
    "use strict";

    var BaseModel = require("models/BaseModel");
    var ListItemsCollection = require("ui/list/js/collections/ListItemsCollection");

    var DEFAULT_GROUP_ID = "listComponentDefaultGroupId";
    var SPECIAL_GROUP_ID = "listComponentSpecialGroupId";

    var ListGroupModel = BaseModel.extend({
        defaults: function() {
            return  {
                id: "",
                titleVisible: false,
                groupCollapsible: false,
                className: "",
                items: new ListItemsCollection()
            };
        },

        isDefaultGroup: function() {
            return (this.id === DEFAULT_GROUP_ID);
        },
        isSpecialGroup: function() {
            return (this.id === SPECIAL_GROUP_ID);
        },
        isGroupCollapsible: function() {
            return (this.get("groupCollapsible") === true);
        },
        getTitleVisible: function() {
            return this.get("titleVisible");
        },
        setTitleVisible: function(titleVisible) {
            this.set("titleVisible", titleVisible);
        },
        isTitleVisible: function() {
            return (this.getTitleVisible() === true);
        },
        getClassName: function() {
            return this.get("className");
        },
        setClassName: function(className) {
            this.set("className", className);
        },
        setItemsComparator: function(itemsComparator) {
            this.getItems().setComparator(itemsComparator);
            if (itemsComparator) {
                this.getItems().sort();
            }
        },
        getItemsComparator: function() {
            return this.getItems().getComparator();
        },
        getItems: function() {
            return this.get("items");
        },
        getItem: function(itemId) {
            return this.getItems().get(itemId);
        }
    });

    ListGroupModel.DEFAULT_GROUP_ID = DEFAULT_GROUP_ID;
    ListGroupModel.SPECIAL_GROUP_ID = SPECIAL_GROUP_ID;
    ListGroupModel.Collection = ListItemsCollection;

    return ListGroupModel;
});